import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Palmtree, Mail } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

// Auto-expires after this moment (no redeploy needed to remove it).
const VACATION_END = new Date("2026-07-29T23:59:59");
const EMAIL = "info@tr-premiumcars.be";
const SS_KEY = "tr_vacation_dismissed_v1";

const COPY = {
  nl: {
    tag: "Vakantie",
    title: "Wij zijn even weg",
    body: "Onze showroom is afwezig tot en met 29 juli. Je kan ons in tussentijd steeds bereiken via e-mail — we antwoorden zo snel mogelijk!",
    cta: "Mail ons",
    close: "Sluiten",
  },
  fr: {
    tag: "Vacances",
    title: "Nous sommes absents",
    body: "Notre showroom est fermé jusqu'au 29 juillet inclus. Vous pouvez nous joindre par e-mail entre-temps — nous répondons au plus vite !",
    cta: "Écrivez-nous",
    close: "Fermer",
  },
  en: {
    tag: "Holiday",
    title: "We're away for a bit",
    body: "Our showroom is away until 29 July. You can still reach us by email in the meantime — we'll reply as soon as we can!",
    cta: "Email us",
    close: "Close",
  },
};

export default function VacationPopup() {
  const { lang } = useI18n();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isPublic = !/^\/(admin|login|dossier)/.test(location.pathname);

  useEffect(() => {
    if (new Date() > VACATION_END) return;
    if (!isPublic) return;
    try {
      if (sessionStorage.getItem(SS_KEY)) return;
    } catch {}
    const t = setTimeout(() => setOpen(true), 900);
    return () => clearTimeout(t);
  }, [isPublic]);

  const dismiss = () => {
    setOpen(false);
    try {
      sessionStorage.setItem(SS_KEY, "1");
    } catch {}
  };

  if (!open) return null;
  const c = COPY[lang] || COPY.nl;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-in fade-in duration-300"
      data-testid="vacation-popup"
      onClick={dismiss}
    >
      <div
        className="relative w-full max-w-md bg-[#1a1a1a] border border-[#c5a76f]/30 rounded-xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={dismiss}
          data-testid="vacation-popup-close"
          aria-label={c.close}
          className="absolute top-3 right-3 text-white/50 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="px-8 pt-9 pb-8 text-center">
          <div className="mx-auto mb-5 w-14 h-14 rounded-full bg-[#c5a76f]/15 flex items-center justify-center">
            <Palmtree className="w-7 h-7 text-[#c5a76f]" />
          </div>
          <div className="text-[#c5a76f] text-[11px] tracking-[0.3em] uppercase mb-2">{c.tag}</div>
          <h2 className="text-white text-2xl font-bold mb-3" style={{ fontFamily: "'Familjen Grotesk', serif" }}>
            {c.title}
          </h2>
          <p className="text-white/60 text-sm leading-relaxed mb-6">{c.body}</p>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="vacation-popup-email"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#c5a76f] text-black text-sm font-semibold tracking-wider uppercase rounded hover:bg-[#d8bd86] transition-colors"
          >
            <Mail className="w-4 h-4" /> {c.cta}
          </a>
          <div className="mt-3 text-white/40 text-xs">{EMAIL}</div>
        </div>
      </div>
    </div>
  );
}
